import "primereact/resources/themes/lara-light-cyan/theme.css";
import { Route, Routes } from "react-router-dom";
import BlackList from "../pages/BlackList";
import DashboardAdm from "../pages/DashboardAdm";
import LoginAdm from "../pages/LoginAdm";
import ManageAccesses from "../pages/ManageAccesses";
import ProposalPage from "../pages/Proposal/Admin";
import { PrivateRoute } from "../pages/PrivateRoute";

export const RoutesUrl = () => {
  return (
    <Routes>
      <Route path="/" element={<LoginAdm />} />
      <Route element={<PrivateRoute />}>
        <Route path="/dashboard" element={<DashboardAdm />} />
        <Route path="/dashboard/manage" element={<ManageAccesses />} />
        <Route path="/dashboard/list" element={<BlackList />} />
        <Route path="/dashboard/proposal" element={<ProposalPage />} />
      </Route>
    </Routes>
  );
};
